export default "__VITE_ASSET__DORJxK_M__"